<template>
    <div id="main-mobile">
        <img class="absolute decor-one" width="100%" height="500px" src="@/assets/images/main/Rectangle 671.png">
        <img class="absolute decor-two" width="66%" height="65px" src="@/assets/images/main/Vector 41.png">
        <div class="absolute decor-three">
            <div class="flex-center">
                <img width="50" src="@/assets/images/logo.svg">
                <div class="logo ml-5 clr-white mobile">Tasko</div>
            </div>
        </div>
        <h1 class="absolute decor-five roboto-normal-18 clr-white z-index-10">Я помогу тебе создавать, структурировать и хранить заметки.</h1>
        <img class="absolute decor-six z-index-10" height="102px" src="@/assets/images/main/Group 476.png">
        <img class="absolute decor-seven" width="188px" height="194px" src="@/assets/images/main/Group 512 1.png">
        <img class="absolute decor-eight" width="86%" height="125px" src="@/assets/images/main/Vector 42.png">
        <img class="absolute decor-nine" width="100%" src="@/assets/images/main/Rectangle 673.png">
        <img class="absolute decor-ten" width="14%" height="36px" src="@/assets/images/main/Rectangle 672.png">
        <div class="absolute decor-eleven">
            <!-- <HomeButton/> -->
        </div>
        <div class="absolute decor-eleven-second">
            <HomeButtonEnter/>
        </div>
        <img class="absolute decor-twelve z-index-10 mt-n4 ml-5" width="77%" src="@/assets/images/main/Designlazy_macbook-mockup 4.png">
        <img class="absolute decor-twelve" width="91%" src="@/assets/images/main/Group 632.png">
        <div class="absolute decor-thirteen z-index-10">
            <div class="roboto-bold-24 clr-blue pointer z-index-100">О приложении</div>
            <v-icon medium color="light-blue accent-4" class="mt-6">mdi-layers-triple</v-icon>
            <h2 class="roboto-700-18 clr-black-38 mt-5">Заметки: простые и сложные</h2>
            <div class="roboto-normal-18 clr-black-38 mt-6 mr-8">
                Вы можете построить в приложении сложную структуру, добавить разделы, подразделы и задачи, а можете создать быструю заметку в один клик, если вам срочно понадобилось что-то записать
            </div>
            <!-- <v-icon medium color="light-blue accent-4" class="mt-6">mdi-bell</v-icon>
            <div class="roboto-700-18 clr-black-38 mt-5">Напоминания и задачи</div>
            <div class="roboto-normal-18 clr-black-38 mt-6 mr-8">
                Вы можете создавать задачи, устанавливать срок исполнения, настраивать уведомления и приложение напомнит вам о самом важном
            </div> -->
            <img class="mt-12" src="@/assets/images/main/Group 633.png">
            <div class="roboto-700-18 clr-black-38 mt-12">Создание раздела</div>
            <!-- <div class="roboto-normal-18 clr-black-38 mt-6 mr-8">
                Здесь будет анимация, будут меняться картинки, а внизу будет описание того, что происходит
            </div> -->
            <div class="roboto-bold-24 clr-green pointer mt-12">Как это работает</div>
            <div class="flex-center mt-8">
                <img src="@/assets/images/main/bar_top.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Раздел</div>
                    <div class="roboto-700-18 clr-black-38">Кулинария</div>
                </div>
            </div>
            <div class="border"></div>
            <div>
                <div class="arrow arrow-one"></div>
                <div class="arrow-right arrow-right-one"></div>
            </div>
            <div class="flex-center mt-n7 ml-10">
                <img src="@/assets/images/main/bar_left.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Подраздел</div>
                    <div class="roboto-700-18 clr-black-38">Салаты</div>
                </div>
            </div>
            <div>
                <div class="arrow arrow-two"></div>
                <div class="arrow-right arrow-right-two"></div>
            </div>
            <div class="flex-center mt-n7 notice">
                <img src="@/assets/images/main/text_align_left.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Заметка</div>
                    <div class="roboto-700-18 clr-black-38">Оливье</div>
                </div>
            </div>
            <div class="roboto-normal-14  clr-black-38 recipe">Рецепт</div>
            <div>
                <div class="arrow arrow-three"></div>
                <div class="arrow-right arrow-right-three"></div>
            </div>
            <div class="flex-center mt-n7 ml-10">
                <img src="@/assets/images/main/bar_left.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Подраздел</div>
                    <div class="roboto-700-18 clr-black-38">Супы</div>
                </div>
            </div>
            <div>
                <div class="arrow arrow-four"></div>
                <div class="arrow-right arrow-right-four"></div>
            </div>
            <div class="flex-center mt-n6 notice">
                <img src="@/assets/images/main/checkbox_checked.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Выполненная задача</div>
                </div>
            </div>
            <div class="roboto-700-18 clr-black-38 completed">Научиться делать солянку</div>
            <div>
                <div class="arrow arrow-five"></div>
                <div class="arrow-right arrow-right-five"></div>
            </div>
            <div class="flex-center mt-n7 ml-10">
                <img src="@/assets/images/main/bar_left.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Подраздел</div>
                    <div class="roboto-700-18 clr-black-38">Закуски</div>
                </div>
            </div>
            <div class="border-small"></div>
            <div class="border-level border-level-one"></div>
            <div class="flex-center task">
                <img src="@/assets/images/main/checkbox.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Задача</div>
                    <div class="roboto-700-18 clr-black-38">Сделать наггетсы</div>
                </div>
            </div>
            <div class="border-level border-level-two"></div>
            <div class="flex-center task">
                <img src="@/assets/images/main/calendar.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Когда</div>
                    <div class="roboto-700-18 clr-black-38">21.03.2021 в 12:00</div>
                </div>
            </div>
            <div class="border-level border-level-three"></div>
            <div class="flex-center task">
                <img src="@/assets/images/main/notification_outline.png">
                <div class="ml-3">
                    <div class="roboto-400-14 clr-black-38">Уведомить заранее</div>
                    <div class="roboto-700-18 clr-black-38">Да</div>
                </div>
            </div>
        </div>
        <img class="absolute decor-fourteen" width="100%" height="58px" src="@/assets/images/main/Vector 44.png">
        <img class="absolute decor-fifthteen" width="100%" height="360px" src="@/assets/images/main/Rectangle 675.png">
        <img class="absolute decor-sixteen" width="100%" height="135px" src="@/assets/images/main/Vector 45.png">
        <img class="absolute decor-seventeen" heigth="100%" width="100%" src="@/assets/images/main/Rectangle 677.png">
        <img class="absolute decor-eighteen" src="@/assets/images/main/Group 634.png">
        <div class="absolute decor-nineteen">
            <!-- <HomeButton class="button-blue"/> -->
        </div>
        <div class="absolute decor-nineteen-second">
            <HomeButtonEnter class="button-blue"/>                
        </div>
        <div class="absolute decor-twenty roboto-normal-14 clr-black-5f">
            <div class="mt-2">О Проекте</div>
            <div class="mt-2">FAQ</div>
            <div class="pointer mt-2" @click="toDataPolitic()">Документы, определяющие политику в отношении обработки персональных данных </div>
            <div class="pointer mt-2" @click="toPersonalAgreement()">Согласие на обработку персональных данных, собираемых на сайте</div>
            <div class="pointer mt-2" @click="toUserAgreement()">Пользовательское соглашение</div>
            <div class="pointer mt-2" @click="toLicense()">Лицензионное соглашение</div>
        </div>
        <img class="absolute decor-twenty-one" width="100%" height="443px" src="@/assets/images/main/Rectangle 674.png">
    </div>
</template>

<script>
import HomeButton from './HomeButton.vue'
import HomeButtonEnter from './HomeButtonEnter.vue'
export default {
    name: 'Main',
    data() {
        return {
            localHost: window.location.href
        }
    },
    components: {
        HomeButton,
        HomeButtonEnter
    },
    methods: {
        toDataPolitic() {
            window.location=`${this.localHost}terms/data_politic_en.html`
        },
        toPersonalAgreement() {
            window.location=`${this.localHost}terms/personal_agreement_en.html`
        },
        toUserAgreement() {
            window.location=`${this.localHost}terms/user_agreement_en.html`
        },
        toLicense() {
            window.location=`${this.localHost}terms/license_en.html`
        }
    },
}
</script>

<style lang="scss" scoped>
$clr-black: #000000;
$clr-white: #FFFFFF;
#main-mobile {
    .decor-one {
        top:0%;
        left:0%;
    }
    .decor-two {
        top:0%;
        left:0%;
    }
    .decor-three {
        top:88px;
        left: 33px;
        .decor-four {
            margin-top:-3px
        }
    }
    .decor-five {
        top: 161px;
        left: 33px;
    }
    .decor-six {
        top: 253px;
        left: 33px;
    }
    .decor-seven {
        top: 229px;
        right: 0%;
    }
    .decor-eight {
        top: 351px;
        right: 0%;
        min-width: 86%;
    }
    .decor-nine {
        left:0%;
        top:427px;
        height:2790px;  
    }
    .decor-ten {
        left:6%;
        top:440px;
    }
    .decor-eleven {
        display: flex;
        justify-content: center;
        top:527px;
        width:100%;
        .button  {
            background: #16F68B;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 8px;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 31px;
            text-align: center;
            color: $clr-black;
            height: 65px;
            width: 80%;
            max-width:300px;
            letter-spacing: 0.5px;
            margin-left:10%;
        }
        .registration {
            margin-left:20%;
            word-wrap: break-word;
        }
    }
    .decor-eleven-second {
        display: flex;
        justify-content: center;
        top:617px;
        width:100%;
    }
    .decor-twelve {
        top:740px;
        left:0%;
    }
    .decor-thirteen {
        top:959px;
        left:8%;
        .border {
            margin:170px 0 0 -150px;
            border: 1px solid #666666;
            width:324px;
            transform: rotate(90deg);
        }
        .arrow {
            width:15px;
            border: 1px solid #666666;
        }
        .arrow-right {
            width: 10px;
            height: 10px;
            border-top: 1px solid #666666;
            border-right: 1px solid #666666;
            transform: rotate(45deg);
        }
        .arrow-one {
            margin: -100px 0 0 12px;
        } 
        .arrow-right-one {
            margin: -6px 0 0 16px;
        }
        .arrow-two {
            margin: -20px 0 0 160px;
        } 
        .arrow-right-two {
            margin: -6px 0 0 164px;
        }
        .notice {
            margin-left:190px;
            width:100px
        }
        .recipe {
            margin:18px 0 0 228px
        }
        .arrow-three {
            margin: 70px 0 0 12px;
        }
        .arrow-right-three {
            margin: -6px 0 0 16px;
        }
        .arrow-four {
            margin: -20px 0 0 160px;
        } 
        .arrow-right-four {
            margin: -6px 0 0 164px;
        }
        .completed {
            margin:0 0 0 222px;
            width:100px
        }
        .arrow-five {
            margin: 50px 0 0 12px;
        }
        .arrow-right-five {
            margin: -6px 0 0 16px;
        }
        .border-small {
            margin: 55px 0 0 90px;
            border: 1px solid #666666;
            width:149px;
            transform: rotate(90deg);
        }
        .border-level {
            border: 1px solid #666666;
            width:5px;
        }
        .task {
            margin: -35px 0 0 175px;
            width:100px
        }
        .border-level-one {
            margin:-76px 0 0 165px;
        }
        .border-level-two {
            margin:45px 0 0 165px;
        }
        .border-level-three {
            margin:40px 0 0 165px;
        }
    }
    .decor-fourteen {
        top: 2600px;
        min-width: 375px;
    }
    .decor-fifthteen {
        top: 2657px;
        min-width: 375px;
    }
    .decor-sixteen {
        top: 2884px;
        min-width: 375px;
    }
    .decor-seventeen {
        top: 3019px
    }
    .decor-eighteen {
        top: 2550px;
        left:13%;
    }
    .decor-nineteen {
        top: 2720px;
        width: 100%;
        display: flex;
        justify-content: center;
        left: 0;
    }
    .decor-nineteen-second {
        top: 2810px;
        width: 100%;
        display: flex;
        justify-content: center;
        left: 0;
    }
    .decor-twenty {
        top:2978px;
        left:11%;
    }
    .decor-twenty-one {
        top:1507px;
    }
}
</style>